export const caracteristicasSectionKeys = [
    "dataReferencia",
    "cetip",
    "versaoDocumento",
    "indexador",
    "tipoAtivo",
    "taxaJuros",
    "liquidezDiaria",
    "perpetuidade"
]